(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("i18n-iso-639-1", [], factory);
	else if(typeof exports === 'object')
		exports["i18n-iso-639-1"] = factory();
	else
		root["i18n-iso-639-1"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition